'use es6';

import { connect } from 'react-redux';
import CommonMessage from 'conversations-visitor-message-history/common-message/CommonMessage';
import { isStarted } from '../../../threads/operators/isStarted';
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { toggleOpen } from '../../../actions/WidgetActions';
import { getIsMobile } from '../../../selectors/getIsMobile';
import { getWidgetDataLanguage } from '../../../widget-data/selectors/widgetDataSelectors';
const mapStateToProps = state => {
  const selectedThread = getSelectedThread(state);
  return {
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state),
    locale: getWidgetDataLanguage(state)
  };
};
const mapDispatchToProps = {
  publishMessage: publishVisitorMessage,
  toggleOpen
};
export default connect(mapStateToProps, mapDispatchToProps)(CommonMessage);